import Category from "./Category";

export default {
    "category-page": Category
};
